export const MAX_PEOPLE_IN_MENU = 5;
export const MAX_TEAMS_IN_MENU = 3;
export const VOID_FUNC = () => undefined;